module.exports = __webpack_public_path__ + "static/media/logoorange.b3c9348b.png";